export default __webpack_public_path__ + "static/media/sortIcon.ca2f50ef.svg";